/** Formats a length in feet the way a builder writes it: 2.75 → 2'9", 5 → 5'. */
export function feetInches(feet: number): string {
  const totalInches = Math.round(feet * 12);
  const ft = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return inches === 0 ? `${ft}'` : `${ft}'${inches}"`;
}

/** A footprint as a builder reads it: width by depth. */
export function footprintLabel(w: number, d: number): string {
  return `${feetInches(w)} × ${feetInches(d)}`;
}
